import { CategoryBase } from '@shared/utils/category';
import { EvidenceOfficerBase, EvidenceStatus, EvidenceType, FileShareTypes, OpenAiTaskStatus, FileTranscriptionStatus } from '@shared/utils/evidence-management';
import { DeviceTypes, DeviceStatuses } from '@shared/utils/device';

export class EvidenceAndPreview {
  constructor(public evidence: EvidenceDetails, public preview: string | null) {}
}

export class EvidenceDetails {
  constructor(
    public evidenceUrl: string,
    public shareType: FileShareTypes,
    public categories: CategoryBase[],
    public tags: Tag[],
    public descriptionCad: string,
    public cadReportCategories: CadReportCategory[],
    public location: string,
    public device: Device,
    public agency: AgencyBase,
    public removeSheduledOn: Date | undefined,
    public removedOn: Date | undefined,
    public md5Checksum: string,
    public sha256Checksum: string,
    public title: string,
    public incidentNumber: string,
    public incidentCadNumber: string,
    public type: EvidenceType,
    public thumbnailFullPath: string,
    public createdOn: Date,
    public originalEvidenceName: string,
    public recordedOn: Date,
    public status: EvidenceStatus,
    public description: string,
    public officer: EvidenceOfficerBase,
    public isLocked: boolean,
    public retentionCategories: string[] | null,
    public actualFileDate: Date | null,
    public videoInfo: Video | null,
    public uid: string,
    public aiSummaryStatus: OpenAiTaskStatus,
    public transcriptionStatus: FileTranscriptionStatus,
    public canBeTranscribed: boolean,
    public totalCases?: number
  ) {}
}

export class Tag {
  constructor(public value: string, public uid: string) {}
}

export class CadReportCategory {
  constructor(public name: string, public uid: string) {}
}

export class Device {
  constructor(
    public name: string,
    public serialNumber: string,
    public manufacturer: string,
    public model: string,
    public deviceType: DeviceTypes,
    public deviceStatus: DeviceStatuses
  ) {}
}

export class AgencyBase {
  constructor(public name: string, public shortName: string, public uid: string) {}
}

export class Video {
  constructor(public duration: number) {}
}

export class EvidenceLockBase {
  constructor(public lockCode: string) {}
}

export class Location {
  constructor(public address: string | null, public description: string | null, public latitude: number | null, public longitude: number | null) {}
}

export class SelfRedactionProgress {
  constructor(public fileUid: string, public progress: number, public path: string | null) {}
}

export class TranscriptionSummary {
  constructor(public status: OpenAiTaskStatus, public summary: string) {}
}

export class AiLabeling {
  constructor(public status: OpenAiTaskStatus, public potentialSummary: string, public potentialCategories: string) {}
}
